export default function Footer() {
  return (
    <footer className="bg-[#060e1a] border-t border-white/10 pt-12 pb-8">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="flex flex-col md:flex-row items-center md:items-start justify-between gap-8 mb-10">
          {/* Brand */}
          <div className="flex flex-col items-center md:items-start gap-4">
            <img
              src="https://static.readdy.ai/image/08d571f8ebf239a419d6b3e9dcb7aa91/8ecda6c4b9269ddfaefdbd2a926c38bd.png"
              alt="The Recruiting Playbook"
              className="h-12 w-auto object-contain"
            />
            <p className="font-body text-sm text-white/45 max-w-xs text-center md:text-left leading-relaxed">
              The complete guide for parents navigating college athletic recruiting — from Freshman year to Signing Day.
            </p>
            <a
              href="https://instagram.com/the_recruitingplaybook"
              rel="nofollow noopener noreferrer"
              target="_blank"
              className="flex items-center gap-2 text-white/50 hover:text-[#f5a623] transition-colors cursor-pointer"
            >
              <div className="w-5 h-5 flex items-center justify-center">
                <i className="ri-instagram-fill text-lg" />
              </div>
              <span className="font-body text-sm">@the_recruitingplaybook</span>
            </a>
          </div>

          {/* Links */}
          <div className="flex flex-wrap justify-center md:justify-end gap-x-8 gap-y-3">
            {[
              { label: 'Privacy Policy', href: '#' },
              { label: 'Terms of Service', href: '#' },
              { label: 'Contact Us', href: 'mailto:hello@therecruitingplaybook.com' },
              { label: 'Refund Policy', href: '#' },
            ].map((link) => (
              <a
                key={link.label}
                href={link.href}
                className="font-body text-sm text-white/45 hover:text-[#f5a623] transition-colors whitespace-nowrap cursor-pointer"
              >
                {link.label}
              </a>
            ))}
          </div>
        </div>

        {/* Divider */}
        <div className="border-t border-white/10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="font-body text-xs text-white/30 text-center sm:text-left">
            &copy; {new Date().getFullYear()} The Recruiting Playbook. All rights reserved.
          </p>
          <p className="font-body text-xs text-white/20 text-center sm:text-right">
            Scholarships. Exposure. Results.
          </p>
        </div>
      </div>
    </footer>
  );
}
